// WebSocket 接続の生存管理に関する定数の単一正本。
//
// クライアント（keepalive ping の送信間隔）とサーバ（接続登録行の TTL）で別々に定義していたため、
// 「TTL が ping 間隔と同値（5 分）」という危険な組み合わせが無言で成立し、PC スリープ・タブ凍結で
// ping が 1 回滞っただけで接続登録だけが TTL 失効する「サイレント同期断」を起こした
// （2026-07-06 本番障害。API Gateway ClientError 約 3.4 万件）。
// 双方の値をここへ集約し、両者の関係（TTL は ping 間隔の 3 倍以上）をテストで固定できるようにする。

/**
 * クライアントが送る keepalive ping の間隔（ミリ秒）。
 * API Gateway WebSocket のアイドルタイムアウト（10 分。AWS 側の仕様値で変更できない外部制約）より
 * 十分短くする。
 */
export const REALTIME_KEEPALIVE_INTERVAL_MS = 5 * 60 * 1000;

/**
 * 接続登録行（CONN# / CONN_INDEX#）の TTL（秒）。
 * $disconnect が来ないまま残ったゴースト接続の回収用で、生きている接続は keepalive ping と
 * viewer.sync が都度延長する。ping が 2 回落ちても失効しないよう、ping 間隔の 3 倍以上を保つ。
 */
export const REALTIME_CONNECTION_TTL_SECONDS = 60 * 15;
